import {ValueObject} from '@s-ui/domain'

import {ImageResourcesValueObject} from './ImageResourcesValueObject.js'

export class ImagesResourcesValueObject extends ValueObject {
  #images

  static IMAGE_RESOURCE_TYPE = 'IMAGE'

  constructor({images}) {
    super()
    this.#images = images
  }

  static createFromImages({images = []}) {
    return new ImagesResourcesValueObject({
      images: images.map(image => ImageResourcesValueObject.createFromImageUrl({url: image}))
    })
  }

  static createFromListingApi({resources}) {
    return new ImagesResourcesValueObject({
      images: resources
        .filter(resource => resource.type === this.IMAGE_RESOURCE_TYPE)
        .map(resource => ImageResourcesValueObject.createFromResource({resource}))
    })
  }

  get images() {
    return this.#images.map(image => image.value)
  }

  get value() {
    return this.images
  }
}
